import store from "@/store";

function redirectWxUrl() {
	var href = "/api/wx/cp/oauth2?modulesUuid=" + store.state.key + "&url=" + window.location.href;
	window.location.href = href;
}

export function comroomAuth(to, from, resolve, reject) {
	debugger
	console.log(store.state.token, store.state.key);
	if (store.state.token && store.state.key) {
		store.dispatch("setProjectId", "room");
		resolve();
	} else {
		store.dispatch("setProjectId", "room");
		if (to.query.code) {
			store.dispatch("getTokenByCode", { code: to.query.code, projectId: "room" }).then(() => {
				resolve();
			}).catch(error => {
				reject();
				this.navigate("/error");
			});
		} else {
			redirectWxUrl();
		}
	}
}

export function shopfloorAuth(to, from, resolve, reject) {
	if (store.state.token && store.state.key) {
		store.dispatch("setProjectId", "device");
		resolve();
	} else {
		store.dispatch("setProjectId", "device");
		if (to.query.code) {
			store.dispatch("getTokenByCode", { code: to.query.code, projectId: "device" }).then(() => {
				resolve();
			}).catch(error => {
				reject();
				this.navigate("/error");
			});
		} else {
			redirectWxUrl();
		}
	}
}
